export class stockDropdownData{
  unitId?: number;
  saleOrderId?:number;
  itemSubCategoryId?:number;
  itemSubCategoryName?:string;
  itemCategoryId?:number;
  itemId?:number;
  brandId?:number;
  locationId?:number;
  fromDate?: Date;
toDate?: Date;
dateRange?:string
constructor(unitId?:number,saleOrderId?:number,itemSubCategoryId?:number,itemSubCategoryName?:string,itemCategoryId?:number,itemId?:number,brandId?:number,locationId?:number,fromDate?:Date,toDate?: Date,dateRange?:string){
  this.unitId = unitId;
  this.saleOrderId = saleOrderId;
  this.itemSubCategoryId = itemSubCategoryId;
  this.itemSubCategoryName = itemSubCategoryName;
  this.itemCategoryId = itemCategoryId;
  this.itemId = itemId;
  this.brandId = brandId,
  this.locationId = locationId;
  this.fromDate = fromDate;
  this.toDate = toDate
  this.dateRange = dateRange
}
}